import { Component, Input } from '@angular/core';
import { IRecommendationSiteOpeningHoursItem } from '../../../../../interfaces/route-recommendations/recommendation-task';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'route-itinerary-site-hours',
  templateUrl: './route-itinerary-site-hours.component.html',
  styleUrls: ['./route-itinerary-site-hours.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class RouteItinerarySiteHoursComponent {
  @Input() hours: IRecommendationSiteOpeningHoursItem[] | undefined;
  @Input() scheduledDate: string;

  private readonly WEEKDAY_NAMES = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  showAll = false;

  get scheduledDayOfWeek(): number | null {
    return this.scheduledDate ? new Date(this.scheduledDate).getDay() : null;
  }

  get hasExpandableHours(): boolean {
    return this.hours?.some((h) => !this.isHoursUnspecified(h)) ?? false;
  }

  get scheduledDayHours(): IRecommendationSiteOpeningHoursItem | null {
    if (!this.hours?.length || !this.scheduledDate) return null;
    const dow = new Date(this.scheduledDate).getDay();
    return this.hours.find((h) => h.dayOfWeek === dow) ?? null;
  }

  isSiteClosed(item: IRecommendationSiteOpeningHoursItem): boolean {
    return item.open === 0 && item.close === 0;
  }

  isHoursUnspecified(item: IRecommendationSiteOpeningHoursItem | null): boolean {
    return !item || (item.open == null && item.close == null);
  }

  minutesToTimeString(mins: number | null): string {
    if (mins == null) return '';
    return `${Math.floor(mins / 60)
      .toString()
      .padStart(2, '0')}:${(mins % 60).toString().padStart(2, '0')}`;
  }

  weekdayName(dayOfWeek: number): string {
    //Added an array of weekday names as no simple way of converting the number to the text equivalent - annoying
    return this.WEEKDAY_NAMES[dayOfWeek] ?? '';
  }
}
